module.exports = __webpack_public_path__ + "static/media/Mali.501bbb2c.png";